export default "__VITE_ASSET__JWrMb2fR__"